// extracted by mini-css-extract-plugin
module.exports = {"dayList":"tag-page-module--dayList--3I6IE","titleWrap":"tag-page-module--titleWrap--18450","title":"tag-page-module--title--24UAg"};